import { hydrateRoot } from 'react-dom/client';
import { Globals } from '@bwoty-web/ui-kit';
import TopImageView from '../shared/views/topImage/topImageView';

const initialStateTopImage = window.__INITIAL_STATE_TOP_IMAGE__;
delete window.__INITIAL_STATE_TOP_IMAGE__;
const topImageRoot = document.getElementById('top-image-view');

if (topImageRoot) {
  const {
    topImageContent,
    siteId,
    count,
    compactMode,
    itemType,
    userDevice,
    galleryMode,
    hideCloseButton,
    isAppWebView,
  } = initialStateTopImage;
  hydrateRoot(
    topImageRoot,
    <Globals siteId={siteId}>
      <TopImageView
        siteId={siteId}
        topImageContent={topImageContent}
        count={count}
        compactMode={compactMode}
        itemType={itemType}
        userDevice={userDevice}
        galleryMode={galleryMode}
        hideCloseButton={hideCloseButton}
        isAppWebView={isAppWebView}
      />
    </Globals>,
  );
}
